import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 2, color: 'error.main' }}>
          <Typography variant="body1">
            Something went wrong rendering this field.
          </Typography>
          {(() => {
            try {
              // Check if we're in development mode using multiple methods
              const isDev = import.meta.env.DEV || 
                           import.meta.env.MODE === 'development' ||
                           (typeof process !== 'undefined' && process.env.NODE_ENV === 'development');
              return isDev;
            } catch {
              return false; // Fallback to false if any check fails
            }
          })() && (
            <Typography variant="caption">
              {this.state.error?.message}
            </Typography>
          )}
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
